<template>
  <div>
    <div v-if="menu.child">
      <div v-if="menu.parent.isShow && menu.child.length !== 0">
        <a
          v-b-toggle="'accordion-' + getCollapseName"
          class="item"
          @click="negateIsCollapse">
          <div class="sidemenu-container">
            <span v-if="menu.parent.icon">
              <i
                :class="getMenuIcon"
                aria-hidden="true"/>
            </span>
            <span v-else>
              <img
                v-if="menu.parent.iconUrlNotActive"
                :src="menu.parent.iconUrlNotActive"
                class="left-icon-url">
            </span>
            <span
              class="nav-text toggleable">  {{ menu.parent.name }}
            </span>
            <span style="margin-left: auto">
              <i
                :class="getArrowIcon"
                aria-hidden="true"/>
            </span>
          </div>
        </a>
        <div
          :id="getCollapseName"
          class="collapse--shadow-box">
          <bCollapse
            :id="'accordion-' + getCollapseName"
            v-model="showCollapse"
            visible
            accordion="nested-menus-accordion"
            role="tabpanel">
            <ul>
              <li
                v-for="(child, index) in menu.child"
                :key="index"
                class="menus-list">
                <jNestedMenuUnit
                  :child="child"/>
              </li>
            </ul>
          </bCollapse>
        </div>
      </div>
    </div>

    <div v-else>
      <router-link
        v-if="menu.parent.isShow && menu.parent.href"
        :to="menu.parent.href"
        active-class="div--active"
        exact
        class="div--menu"
        tag="div">
        <a class="a--none color--white">
          <div class="sidemenu-container">
            <span v-if="menu.parent.icon">
              <i
                :class="getMenuIcon2"
                aria-hidden="true"/>
            </span>
            <span v-else>
              <img
                v-if="ishrefEqualToRoute(menu.parent.href) && menu.parent.iconUrlActive"
                :src="menu.parent.iconUrlActive"
                class="left-icon-url">
              <img
                v-else-if="menu.parent.iconUrlNotActive"
                :src="menu.parent.iconUrlNotActive"
                class="left-icon-url">
            </span>
            <span class="nav-text toggleable">  {{ menu.parent.name }} </span>
          </div>
        </a>
      </router-link>

      <div
        v-else-if="menu.parent.isShow && menu.parent.hrefout"
        :class="{ 'div--active': ishrefoutEqualToWindowLocation(menu.parent.hrefout) }">
        <a
          :href="menu.parent.hrefout"
          class="a--none color--white">
          <div class="sidemenu-container">
            <span v-if="menu.parent.icon">
              <i
                :class="getMenuIcon2"
                aria-hidden="true"/>
            </span>
            <span v-else>
              <img
                v-if="ishrefoutEqualToWindowLocation(menu.parent.hrefout)
                && menu.parent.iconUrlActive"
                :src="menu.parent.iconUrlActive"
                class="left-icon-url">
              <img
                v-else-if="menu.parent.iconUrlNotActive"
                :src="menu.parent.iconUrlNotActive"
                class="left-icon-url">
            </span>
            <span class="nav-text toggleable">  {{ menu.parent.name }} </span>
          </div>
        </a>
      </div>
    </div>

  </div>
</template>

<script>
/* eslint-disable import/no-unresolved,vue/require-default-prop */
/* eslint linebreak-style: ["error", "windows"] */
import jNestedMenuUnit from './jNestedMenuUnit';

export default {
  name: 'JNestedList',
  components: {
    jNestedMenuUnit,
  },
  props: {
    menu: null,
  },
  data() {
    return {
      showCollapse: null,
    };
  },
  computed: {
    getArrowIcon() {
      if (!this.showCollapse) return 'fa fa-angle-right icon--right icon';
      return 'fa fa-angle-right icon--right icon open';
    },
    getCollapseId() {
      return `#collapse${this.menu.parent.name}`;
    },
    getCollapseName() {
      return `collapse${this.menu.parent.name}`;
    },
    getMenuIcon() {
      return `fa fa-${this.menu.parent.icon} left-icon`;
    },
    getMenuIcon2() {
      return `fa fa-${this.menu.parent.icon} color--white left-icon`;
    },
  },
  mounted() {
    if (this.menu.child !== undefined) {
      this.menu.child.forEach((e) => {
        if (e.href === this.$route.fullPath) {
          this.showCollapse = true;
        }
      });
    }
  },
  methods: {
    ishrefEqualToRoute(href) {
      return this.$route.path === href;
    },
    ishrefoutEqualToWindowLocation(hrefout) {
      return window.location.href === hrefout;
    },
    negateIsCollapse() {
      this.showCollapse = !this.showCollapse;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/layouts/sidebar/jNestedMenu.vue